export const ACCOUNT_STATUS_ERROR_CODE = 'D02'
export const ACCOUNT_GROUP_RESTRICTION_ERROR_CODE = 'E01'
export const CART_FAIL_STATUS_ERROR_CODE = 'ERP_FAIL'

export const TAX_CALCULATION_STATUS_ERROR = 'ERROR'
